import { useStore } from "..";
export const useProjectQuota = () => useStore(({ projectQuota }) => projectQuota);
